import React, { useEffect, useState } from 'react';

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const [data, setData] = useState([]);

  async function getInputData() {
    try {
      let res = await fetch("/api/testimonial", {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      res = await res.json();
      if (res.result === "Done") {
        setData(res.data);
      } else {
        alert("Record Not Found");
      }
    } catch (error) {
  
    }
  }

  useEffect(() => {
    getInputData();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (data.length > 0) {
        setIndex((prev) => (prev + 1) % data.length);
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [data]);

  if (data.length === 0) return <p>Loading testimonials...</p>;

  return (
    <>
      <div className="testimonial-main">
        <h1>Testimonials</h1>
        <div className="testimonial-container">
          <div className="testimonial-card">
            <div className="stars">
              ⭐️⭐️⭐️⭐️⭐️
              <img
                src={`${data[index].pic}`}
                className="float-start rounded-circle mx-3"
                height={50}
                loading='lazy'
                title='V Hotel The Grnad Shoba tesimonials'
                width={50}
                alt="V Hotel The Grnad Shoba reviews"
              />
              {/* You can add star ratings here if you want */}
            </div>

            <p className="testimonial-text">
  {data[index].message?.split(" ").slice(0, 35).join(" ")}
  
  {/* {data[index].message?.split(" ").slice(11, 20).join(" ")}" */}
</p>
            <p className="fw-bold">{data[index].name}</p>
            <div className="testimonial-logo">V The Grand Shoba Hotel</div>
          </div>
        </div>
      </div>
    </>
  );
}
